(() => {
  const initTrufaHome = (root) => {
    if (!root || root.dataset.trufaReady === 'true') return;
    root.dataset.trufaReady = 'true';

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const reveals = root.querySelectorAll('.trufa-reveal');

    if (reduceMotion || !('IntersectionObserver' in window)) {
      reveals.forEach((element) => element.classList.add('is-visible'));
    } else {
      const revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

      reveals.forEach((element, index) => {
        element.style.transitionDelay = `${Math.min((index % 4) * 55, 165)}ms`;
        revealObserver.observe(element);
      });
    }

    const heroMedia = root.querySelector('[data-trufa-parallax]');
    if (heroMedia && !reduceMotion && window.matchMedia('(pointer: fine)').matches) {
      root.querySelector('.trufa-hero')?.addEventListener('pointermove', (event) => {
        const bounds = event.currentTarget.getBoundingClientRect();
        const x = (event.clientX - bounds.left) / bounds.width - 0.5;
        const y = (event.clientY - bounds.top) / bounds.height - 0.5;
        heroMedia.style.transform = `translate3d(${x * -8}px, ${y * -6}px, 0) scale(1.012)`;
      });
      root.querySelector('.trufa-hero')?.addEventListener('pointerleave', () => {
        heroMedia.style.transform = '';
      });
    }

    root.querySelectorAll('a[href^="#"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const id = link.getAttribute('href');
        if (!id || id === '#') return;
        const target = root.querySelector(id) || document.querySelector(id);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });

    root.querySelectorAll('.trufa-accordion__item').forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        root.querySelectorAll('.trufa-accordion__item[open]').forEach((other) => {
          if (other !== item) other.removeAttribute('open');
        });
      });
    });

    const toast = root.querySelector('[data-trufa-toast]');
    const toastTitle = root.querySelector('[data-trufa-toast-title]');
    const toastCopy = root.querySelector('[data-trufa-toast-copy]');
    let toastTimer;

    const showToast = (title, copy) => {
      if (!toast) return;
      window.clearTimeout(toastTimer);
      toastTitle.textContent = title;
      toastCopy.textContent = copy;
      toast.hidden = false;
      toast.classList.remove('is-entering');
      requestAnimationFrame(() => toast.classList.add('is-entering'));
      toastTimer = window.setTimeout(() => { toast.hidden = true; }, 6500);
    };

    root.querySelector('[data-trufa-toast-close]')?.addEventListener('click', () => {
      toast.hidden = true;
      window.clearTimeout(toastTimer);
    });

    const updateCartCount = async () => {
      try {
        const routeRoot = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${routeRoot}cart.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const cart = await response.json();
        root.querySelectorAll('[data-trufa-cart-count]').forEach((counter) => {
          counter.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('trufa:cart-updated', { detail: cart }));
      } catch (_) {
        // The form remains usable even if cart count synchronization fails.
      }
    };

    root.querySelectorAll('.trufa-quick-add').forEach((form) => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const button = form.querySelector('button[type="submit"]');
        const label = form.querySelector('[data-add-label]');
        const previousLabel = label?.textContent || 'Agregar al carrito';

        if (button?.disabled) return;
        if (button) button.disabled = true;
        if (label) label.textContent = 'Agregando…';

        try {
          const routeRoot = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${routeRoot}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });
          const result = await response.json();

          if (!response.ok) throw new Error(result.description || 'No pudimos agregar esta variante.');

          if (label) label.textContent = 'Agregada ✓';
          showToast('Listo.', `${result.product_title || result.title || 'Tu pieza'} está en tu carrito.`);
          await updateCartCount();
          window.setTimeout(() => { if (label) label.textContent = previousLabel; }, 1800);
        } catch (error) {
          if (label) label.textContent = previousLabel;
          showToast('No se pudo agregar.', error.message || 'Inténtalo de nuevo o abre la ficha del producto.');
        } finally {
          if (button) button.disabled = false;
        }
      });
    });
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-trufa-home]').forEach(initTrufaHome);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
